// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./AuthContext";
import { MathJaxContext } from "better-react-mathjax";
import 'katex/dist/katex.min.css';
import ReactGA from 'react-ga4';

// Replace with your ID
ReactGA.initialize("G-CT97NN7VC4");

// Optional: Track initial page view
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

const config = {
  loader: { load: ["[tex]/ams"] },
  tex: { packages: { "[+]": ["ams"] } },
};

// ✅ Correct order: declare `root` AFTER everything is ready
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <MathJaxContext version={3} config={config}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MathJaxContext>
  </React.StrictMode>
);
